//console.log("src/utils/types.js");

export default [
  {
    sys: {
      id: "102",
    },
    fields: {
      size: "10",
      lapp: "1",
      laph: "0",
      amount: 0,
      F0: 100,
      F1: 64,
      F2: 82,
    },
  },
  {
    sys: {
      id: "212",
    },
    fields: {
      size: "20",
      lapp: "2",
      laph: "1",
      amount: 0,
      F0: 200,
      F1: 169,
      F2: 164,
    },
  },
  {
    sys: {
      id: "222",
    },
    fields: {
      size: "20",
      lapp: "5",
      laph: "2",
      amount: 0,
      F0: 200,
      F1: 128,
      F2: 123,
    },
  },
  {
    sys: {
      id: "313",
    },
    fields: {
      size: "30",
      lapp: "2",
      laph: "1",
      amount: 0,
      F0: 300,
      F1: 233,
      F2: 246,
    },
  },
  {
    sys: {
      id: "323",
    },
    fields: {
      size: "30",
      lapp: "3",
      laph: "2",
      amount: 0,
      F0: 300,
      F1: 192,
      F2: 205,
    },
  },
  {
    sys: {
      id: "333",
    },
    fields: {
      size: "30",
      lapp: "5",
      laph: "3",
      amount: 0,
      F0: 300,
      F1: 151,
      F2: 164,
    },
  },
  {
    sys: {
      id: "414",
    },
    fields: {
      size: "40",
      lapp: "2",
      laph: "1",
      amount: 0,
      F0: 400,
      F1: 297,
      F2: 328,
    },
  },
  {
    sys: {
      id: "424",
    },
    fields: {
      size: "40",
      lapp: "3",
      laph: "2",
      amount: 0,
      F0: 400,
      F1: 256,
      F2: 287,
    },
  },
  {
    sys: {
      id: "434",
    },
    fields: {
      size: "40",
      lapp: "4",
      laph: "3",
      amount: 0,
      F0: 400,
      F1: 215,
      F2: 246,
    },
  },
  {
    sys: {
      id: "444",
    },
    fields: {
      size: "40",
      lapp: "5",
      laph: "4",
      amount: 0,
      F0: 400,
      F1: 174,
      F2: 205,
    },
  },
];
